import { h } from 'preact';
import cx from 'classnames';
import style from './style';
import WeatherSVGIcon from '../weather-svg-icon/';

/**
 * Render the mini Current Weather component
 * @param  {Object} today      	Current weather information
 * @param  {string} unit        Temperature units in use 'C' or 'F'
 * @param  {boolean} isCelsius	True if 'C' or false if 'F'
 * @return {string}             The rendered component
 */
const CurrentMini = ({ today, unit = 'F', isCelsius, theme }) => {

	let currentTemp = isCelsius ? today.currentTempCels : today.currentTemp;

	return (
		<div class={cx(style.current, style.mini, style[theme])}>
			<div class={style.temperature}>
				<div class={style.miniWrap}>
					<div class={style.icon}>
						<WeatherSVGIcon
							name={today.weatherIconCode}
							class={style.conditionIcon}
						/>
					</div>
					<div class={style.tempWidget}>
						<div class={style.temp}>{currentTemp}&deg;</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default CurrentMini;
